import { ArchivedTasksController } from './archived-tasks.controller'

function archivedTasks () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/directives/archived-tasks/archived-tasks-directive.html?$$REVISION$$',
    controller: ArchivedTasksController
  }
}

export { archivedTasks }
